import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#0f172a] text-slate-300 pt-16 pb-8 border-t border-indigo-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div className="col-span-1 lg:col-span-1">
            <h2 className="text-2xl font-bold text-white mb-6 tracking-tight">
              NCLC <span className="text-indigo-400">2026</span>
            </h2>
            <p className="text-sm leading-relaxed mb-6 text-slate-400">
              Join us for the premier National Conference on Liquid Crystals.
              Experience groundbreaking research, network with experts, and
              explore the future of materials science.
            </p>
            <div className="flex space-x-4">
              {/* Social Icons Placeholder */}
              <button
                type="button"
                aria-label="Social Link 1"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-indigo-500 hover:text-white transition-all"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </button>
              <button
                type="button"
                aria-label="Social Link 2"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-indigo-500 hover:text-white transition-all"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </button>
              <button
                type="button"
                aria-label="Social Link 3"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-indigo-500 hover:text-white transition-all"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z" />
                </svg>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6 uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Home
                </Link>
              </li>
              <li>
                <Link
                  to="/committee"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Committee
                </Link>
              </li>
              <li>
                <Link
                  to="/speakers"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Invited
                  Speakers
                </Link>
              </li>
              <li>
                <Link
                  to="/registration"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Registration
                </Link>
              </li>
              <li>
                <Link
                  to="/sponsorship"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Sponsorship
                </Link>
              </li>
            </ul>
          </div>

          {/* Important Resources */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6 uppercase tracking-wider">
              Resources
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/abstract-submission"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Abstract
                  Submission
                </Link>
              </li>
              <li>
                <Link
                  to="/important-dates"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Important
                  Dates
                </Link>
              </li>
              <li>
                <Link
                  to="/travel"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Travel & Visa
                </Link>
              </li>
              <li>
                <Link
                  to="/accommodation"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Accommodation
                </Link>
              </li>
              <li>
                <Link
                  to="/tourism"
                  className="text-slate-400 hover:text-indigo-400 transition-colors flex items-center"
                >
                  <span className="mr-2 text-indigo-500">›</span> Tourism
                  Information
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6 uppercase tracking-wider">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-indigo-400 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-slate-400">
                  Sharda University,
                  <br />
                  Greater Noida, Uttar Pradesh 201306, India
                </span>
              </li>
              <li className="flex items-center">
                <svg
                  className="w-5 h-5 text-indigo-400 mr-3 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href="mailto:nclc2026@sharda.ac.in"
                  className="text-slate-400 hover:text-indigo-400 transition-colors"
                >
                  nclc.sharda2026@gmail.com
                </a>
              </li>
              <li className="flex items-center">
                <svg
                  className="w-5 h-5 text-indigo-400 mr-3 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <a
                  href="tel:+911596255000"
                  className="text-slate-400 hover:text-indigo-400 transition-colors"
                >
                  +91 (1596) 25-5000
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-slate-500 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} NCLC 2026. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link
              to="#"
              className="text-sm text-slate-500 hover:text-indigo-400 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="#"
              className="text-sm text-slate-500 hover:text-indigo-400 transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
